import {html} from "@isceco/widget-library2/external/lit"
import InputColumn from "@isceco/widget-library2/basic-elements/List/column/InputColumn.js"
import AddRemoveColumn from "@isceco/widget-library2/basic-elements/List/column/AddRemoveColumn.js"
import '@isceco/widget-library2/basic-elements/DateInput/DateInput.js'

export default class VerordnungPeriodeColumns {

  static getColumns() {
    return [
      VerordnungPeriodeColumns.START_COLUMN(),
      VerordnungPeriodeColumns.ENDE_COLUMN(),
      new AddRemoveColumn()
    ]
  }

  static START_COLUMN() {
    return new InputColumn({
      key: 'start',
      text: 'verordnung.create.periode.start',
      render: (i18n, cell, row) => html`
        <isceco-date-input name="start"
                           value="${cell}"
                           open-on-click
                           required
        ></isceco-date-input>
      `
    })
  }

  static ENDE_COLUMN() {
    return new InputColumn({
      key: 'ende',
      text: 'verordnung.create.periode.ende',
      render: (i18n, cell, row) => html`
        <isceco-date-input name="ende"
                           value="${cell}"
                           open-on-click
                           required
        ></isceco-date-input>
      `
    })
  }
}
